/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import dayjs from "dayjs";

export const getAgreementExpiryBadgeLabel = (
  endDate: Date,
  referenceDate: Date = new Date()
): string | null => {
  const daysRemaining = dayjs(endDate).diff(dayjs(referenceDate), "day");

  if (daysRemaining < 0) {
    return null;
  }

  if (daysRemaining <= 7) {
    const dayLabel = daysRemaining === 1 ? "day" : "days";
    return `${daysRemaining} ${dayLabel} left`;
  }

  const weeksRemaining = dayjs(endDate).diff(dayjs(referenceDate), "week");

  if (weeksRemaining <= 12) {
    const weekLabel = weeksRemaining === 1 ? "week" : "weeks";
    return `${weeksRemaining} ${weekLabel} left`;
  }

  const monthsRemaining = dayjs(endDate).diff(dayjs(referenceDate), "month");

  const monthLabel = monthsRemaining === 1 ? "month" : "months";
  return `${monthsRemaining} ${monthLabel} left`;
};
